// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__WpKVx","rootSmall":"AddTileButton_rootSmall__3HgR7"};